import { getFilterModelAsGridFilterSettings } from "../../../../../app/core/components/grid/helpers/grid.helpers";

(function () {
	'use strict';

    angular.module("imApp").factory("stockCountApproveService", ['$ihttp', function ($ihttp) {
		let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1344,
                    parameters: parms || {}
                });
            },
            listPossibles: function (parms) {
                return $ihttp.post({
                    method: 1328,
                    parameters: parms || {}
                });
            },
            listManuals: function (parms) {
                return $ihttp.post({
                    method: 1329,
                    parameters: parms || {}
                });
            },
            listApproved: function (parms) {
                return $ihttp.post({
                    method: 1343,
                    parameters: parms || {}
                });
            },
            approveItem: function (list) {
                return $ihttp.post({
                    method: 1330,
                    parameters: list
                });
            }
		};

		return service;
	}]);
})();
